import {
  Component,
  ContentChild,
  forwardRef,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'control-value-accessor',
    templateUrl: './control-value-accessor.component.html',
    styleUrls: ['./control-value-accessor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ControlValueAccessorComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class ControlValueAccessorComponent implements ControlValueAccessor {
  @Input() setDisabledState = (isDisabled: boolean) => {};
  @ContentChild(TemplateRef, { static: true }) template: TemplateRef<any>;
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue = (value: any) => {
    if (value) {
      this.onChange(value);
    }
  };
  registerOnChange = (onChange: any) => (this.onChange = onChange);
  registerOnTouched = (onTouched: any) => (this.onTouched = onTouched);

  get context() {
    return {
      context: {
        onChange: this.onChange,
        onTouched: this.onTouched,
      },
    };
  }
}
